import React, { RefObject } from "react";
import { View, TouchableOpacity, StyleSheet, TextInput } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import FiltersIcon from "@assets/svg/Wallet/Filter";
import HeaderCard from "./HeaderCard";
import { CrateSummary, ReturnSummary } from "../utils";
import SearchField from "./SearchField";

interface ListHeaderComponentProps {
  numberOfFilters: () => number;
  setShowFilterModal: (show: boolean) => void;
  showFilterIcon: boolean;
  summary: ReturnSummary | CrateSummary;
  title?: string;
  searchPlaceholder: string;
  searchQuery: string;
  setSearchQuery: (text: string) => void;
  onPressCrossIcon: () => void;
  textInputRef: RefObject<TextInput>;
}

const ListHeaderComponent: React.FC<ListHeaderComponentProps> = ({
  numberOfFilters,
  setShowFilterModal,
  showFilterIcon,
  summary,
  title,
  searchPlaceholder,
  searchQuery,
  setSearchQuery,
  onPressCrossIcon,
  textInputRef,
}) => {
  return (
    <View>
      <View style={styles.headerContainer}>
        <Text variant="title_16" style={styles.centeredText}>
          {title}
        </Text>
        {showFilterIcon ? (
          <TouchableOpacity
            testID="mt-filter"
            onPress={() => setShowFilterModal(true)}
            activeOpacity={0.8}
            style={styles.filterContainer}
          >
            {numberOfFilters() > 0 && (
              <View style={styles.filterBadge}>
                <Text variant="caption_1" style={styles.badgeText}>
                  {numberOfFilters()}
                </Text>
              </View>
            )}
            <FiltersIcon />
            <Text variant="body_text_3" style={styles.filterText}>
              {`Filter`}
            </Text>
          </TouchableOpacity>
        ) : null}
      </View>
      {summary ? <HeaderCard summary={summary} /> : null}
      <View style={styles.searchContainer}>
        <SearchField
          searchPlaceholder={searchPlaceholder}
          searchText={searchQuery}
          setSearchText={setSearchQuery}
          onPressCrossIcon={onPressCrossIcon}
          onSearchInputChange={(text) => setSearchQuery(text)}
          testID="rd-search-field"
          hideShadow={false}
          textInputRef={textInputRef}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  filterContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 18,
    paddingHorizontal: 12,
    paddingVertical: 4,
    marginRight: 4,
    borderColor: color.black,
    borderWidth: 1,
  },
  filterBadge: {
    backgroundColor: "rgba(25, 129, 85, 1)",
    padding: 2,
    borderRadius: 20,
    position: "absolute",
    top: -10,
    right: -4,
    minWidth: 20,
    height: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  filterText: {
    marginLeft: 4,
  },
  centeredText: {
    alignSelf: "center",
    color: color.black,
  },
  badgeText: {
    color: color.white,
    fontSize: 13,
    lineHeight: 18,
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginVertical: 12,
  },
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 16,
  },
});

export default ListHeaderComponent;
